import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Users, PlayCircle } from "lucide-react";

const TYPE_STYLES = {
  Degen: "border-fuchsia-500/40 text-fuchsia-300 bg-fuchsia-500/[0.06]",
  Memecoin: "border-amber-500/40 text-amber-300 bg-amber-500/[0.06]",
  "US Stocks": "border-sky-500/40 text-sky-300 bg-sky-500/[0.06]",
  Macro: "border-emerald-500/40 text-emerald-300 bg-emerald-500/[0.06]",
  "On-Chain": "border-violet-500/40 text-violet-300 bg-violet-500/[0.06]",
  Perps: "border-rose-500/40 text-rose-300 bg-rose-500/[0.06]",
  DeFi: "border-teal-500/40 text-teal-300 bg-teal-500/[0.06]",
  NFT: "border-pink-500/40 text-pink-300 bg-pink-500/[0.06]",
};
const IMG_POS = { objectPosition: "center 22%" };

export function AnalystTag({ label }) {
  const cls = TYPE_STYLES[label] || "border-white/15 text-zinc-300 bg-white/[0.04]";
  return (
    <span className={`font-mono-cl text-[10px] tracking-[0.12em] uppercase px-2 py-0.5 rounded-full border ${cls}`}>{label}</span>
  );
}

// Portrait card matching the homepage spotlight aesthetic
export function AnalystCard({ a }) {
  const img = a.profile_image || a.big_picture;
  const primary = (a.types && a.types[0]) || "Markets";
  return (
    <Link to={`/analyst/${a.slug}`} data-testid={`analyst-card-${a.slug}`}
      className="relative rounded-[22px] overflow-hidden group block aspect-[3/4] shadow-[0_20px_60px_-24px_rgba(0,0,0,0.6)]">
      {img ? (
        <img src={img} alt={a.name} style={IMG_POS} className="absolute inset-0 w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-700" />
      ) : (
        <div className="absolute inset-0 grid place-items-center bg-gradient-to-br from-zinc-700 to-zinc-950">
          <span className="font-display text-6xl font-black text-white/25">{(a.name || "?")[0]}</span>
        </div>
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/25 to-black/5" />
      <div className="absolute top-3 left-3 flex flex-wrap gap-1.5 max-w-[80%]">
        {(a.types || []).slice(0, 2).map((t) => <AnalystTag key={t} label={t} />)}
      </div>
      {a.intro_video_url && (
        <div className="absolute top-3 right-3 grid place-items-center w-8 h-8 rounded-full bg-black/55 border border-white/20 backdrop-blur">
          <PlayCircle className="w-4 h-4 text-[#ccff00]" />
        </div>
      )}
      <div className="absolute inset-x-0 bottom-0 p-4">
        <div className="flex items-end justify-between gap-2">
          <div className="min-w-0">
            <h3 className="font-display text-xl font-black text-white leading-none truncate group-hover:text-[#ccff00] transition-colors">{a.name}</h3>
            <p className="text-white/70 text-xs mt-1 truncate">{primary} Desk</p>
          </div>
          <ArrowUpRight className="w-5 h-5 text-white/60 group-hover:text-[#ccff00] transition-colors shrink-0" />
        </div>
        <div className="flex items-center gap-4 mt-2.5 text-[10px] font-mono-cl tracking-[0.12em] uppercase text-white/60">
          <span className="flex items-center gap-1"><Users className="w-3 h-3" /> {a.subscribers || 0}</span>
          <span>{a.published ?? 0} published</span>
        </div>
      </div>
    </Link>
  );
}
